module.exports = __webpack_public_path__ + "img/signature.2463b5bd.png";